import React, { useEffect } from 'react'
import { BrowserProductQueryQuery } from '@generated/graphql'
import './styles.scss'
import { InsiderPriceTag } from '../InsiderShelf/InsiderPriceTag/InsiderPriceTag'
import { sanitizeUrl } from 'src/utils/sanitizeUrl'

type PDPProduct = NonNullable<BrowserProductQueryQuery['product']>

interface Props {
  product: PDPProduct
  isSelected: boolean
  onToggle: () => void
  defaultSelected?: boolean
}

const InsiderPdpProduct: React.FC<Props> = ({
  product,
  isSelected,
  onToggle,
  defaultSelected = false,
}) => {
  const offer = product.offers.offers[0]

  useEffect(() => {
    if (defaultSelected && !isSelected) {
      onToggle()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const productUrl = product?.slug
  const changeUrl = sanitizeUrl(false, productUrl)

  return (
    <div className={`insider-product-card-bt ${isSelected ? 'selected' : ''}`}>
      <div className="buytogether-radio">
        <input type="checkbox" checked={isSelected} onChange={onToggle} />
        <div className="fake-radio"></div>
      </div>
      <a href={changeUrl} className="pdp-link-bt">
        <div
          className="ins-product-box ins-element-link ins-add-to-cart-wrapper ins-sr-api"
          product-id={product?.sku}
          event-collection="true"
        >
          <div className="wrapper-wishlist-image-bt">
            <figure className="product-image-bt">
              <img
                src={product?.image[0].url}
                alt={product?.name}
                loading="lazy"
              />
            </figure>
          </div>
          <div className="product-info-wrapper-bt">
            <div className="product-name-bt">{product?.name}</div>
            <InsiderPriceTag
              listPrice={offer?.listPrice}
              price={offer?.price}
            />
          </div>
        </div>
      </a>
    </div>
  )
}

export default InsiderPdpProduct
